import Vue from 'vue'
import Router from 'vue-router'
import Home from './pages/Home.vue'
import config from '@/../vue.config'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  base: config.publicPath,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: "Startseite"
      }
    },
    {
      path: '/staticDirectory',
      name: 'StaticDirectory',
      component: () => import('./pages/StaticDirectory.vue'),
      meta: {
        title: "Statisches Verzeichnis"
      }
    },
    {
      path: '/tagDirectory',
      name: 'TagDirectory',
      component: () => import('./pages/TagDirectory.vue'),
      meta: {
        title: "Statisches Tag-Verzeichnis"
      }
    },
    {
      path: '/directory',
      name: 'Directory',
      component: () => import('./pages/Directory.vue'),
      meta: {
        title: "Verzeichnis"
      }
    },
    {
      path: '/search',
      name: 'Search',
      component: () => import('./pages/Search.vue'),
      meta: {
        title: "Suche",
        layout: 'default'
      }
    },
    {
      path: '/tags',
      name: 'Tags',
      component: () => import('./pages/Tags.vue'),
      meta: {
        title: "Tags",
        layout: 'default'
      }
    },
    {
      path: '/documents/:documentId',
      name: 'Document',
      component: () => import('./pages/Document.vue'),
      meta: {
        layout: 'narrow'
      }
    },
    {
      path: '/documents/:documentId/pages/:pageNum',
      name: 'Browser',
      component: () => import('./pages/Browser.vue'),
      meta: {
        layout: 'browser'
      }
    },
    {
      path: '/about',
      name: 'About',
      component: () => import(/* webpackChunkName: "about" */ './pages/About.vue'),
      meta: {
        title: "Über",
        layout: 'narrow'
      }
    },
    {
      path: '/imprint',
      name: 'Imprint',
      component: () => import(/* webpackChunkName: "imprint" */ './pages/Imprint.vue'),
      meta: {
        title: "Impressum"
      }
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: () => import(/* webpackChunkName: "Privacy" */ './pages/Privacy.vue'),
      meta: {
        title: "Datenschutz",
        layout: 'narrow'
      }
    }
  ]
})
